import { useAtom } from 'jotai'
import { useEffect } from 'react'

import useCustomToast from '@/hooks/toasts'
import { notificationAtom } from '@/store/gigiChat/Notifications'

const Notifications = () => {
    const [addToast] = useCustomToast()
    const [notification] = useAtom(notificationAtom)

    useEffect(() => {
        if (notification.message) {
            // delay execution so that the stores are in sync
            setTimeout(() => {
                addToast(notification.status, notification.message)
            }, 0)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [notification])
    return <></>
}

export default Notifications
